import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';

export interface FilterState {
  screenId: string | null;
  marketId: any;
  siteInfo: any;
  fsstatusId: any;
  range: FormGroup;
  generatorId: any;
}

@Injectable({
  providedIn: 'root'
})
export class FilterStateService {    
  private initialState: FilterState = {
    screenId: null,
    marketId: -1,
    siteInfo: { sid: '', id: null, siteName: '' },
    fsstatusId: 0,
    generatorId: 0,
    range: new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null)
    })
  };
  private filterStates = new Map<string, FilterState>();
  private filterStateSubkect = new BehaviorSubject<FilterState>(this.initialState);
    
  private _filterState$ = new BehaviorSubject<FilterState>(this.initialState);
  
  public filterState$: Observable<FilterState> = this._filterState$.asObservable();

  constructor() {
    this.filterStates.set("default", this.initialState);
   }

  public getCurrentState(screenId: string): FilterState{
    let currentState = this.filterStates.get(screenId);
    if(!currentState){
        var newState = this.initialState;
        newState.screenId = screenId;
        this.filterStates.set(screenId, newState);
        currentState = newState;
    }
    this.filterStateSubkect.next(currentState);
    return currentState;
  }
  
  updateFilterState(screenId: string, newState: Partial<FilterState>) {
    const currentState = this.getCurrentState(screenId);
    const updatedState = { ...currentState, ...newState };

    this.filterStates.set(screenId, updatedState);
    this.filterStateSubkect.next(updatedState);
  }

  resetFilterState(screenId: string) {
    var newState = this.initialState;
    newState.screenId = screenId;
    this.filterStates.set(screenId, newState);
    this.filterStateSubkect.next(newState);
  }
}